import { useEffect, useState } from 'react';
import { sendMessageAsync } from '../services/ble/extensionUtils';

function useBleExtensionClient() {
    const [isIntroEnabled, setIntroEnabled] = useState(true);

    const checkExtensionStatus = async () => {
        try {
            const data = await sendMessageAsync({type: 'checkExtensionAvailability'}, 2000);
    
            if (data?.available) {
                setIntroEnabled(false);
            }
        } catch (error) {
            console.error('Error in checkExtensionStatus', error);
            setIntroEnabled(true);
        }
    }

    useEffect(() => {
        checkExtensionStatus();

        setInterval(() => {
            checkExtensionStatus();
        }, 1000);
    }, []);

    return { isIntroEnabled };
}

export default useBleExtensionClient;